/**
 * Chi tiết lỗi FastAPI: string hoặc { code, message } (BR-02-02 Row 21).
 */
export function getApiErrorMessage(error: unknown, fallback = 'Có lỗi xảy ra'): string {
  const err = error as { data?: { detail?: unknown }; message?: string }
  const detail = err?.data?.detail
  if (typeof detail === 'string') return detail
  if (detail && typeof detail === 'object' && detail !== null && 'message' in detail) {
    const m = (detail as { message?: unknown }).message
    if (typeof m === 'string') return m
  }
  if (typeof err?.message === 'string') return err.message
  return fallback
}
